import React from "react";
import { Link } from "react-router-dom";

export default function Card({
  companyLogo,
  companyWebsite,
  companyName,
  companyLocation,
  companyDescription,
  companyId,
}) {
  return (
    <div>
      <div className="card border shadow-lg" style={{ width: "100%" }}>
        <div className="card-body">
          <div className="mb-3">
            <Link to={`/company-details/${companyId}`}>
              <div className="d-flex gap-3 align-items-center">
                <img src={companyLogo} width={50} alt="company img" />
                <h5 className="card-title">{companyName}</h5>
              </div>
              <h6 className="card-subtitle my-3 text-muted">
                {companyLocation}
              </h6>
              <p className="card-text">{companyDescription}</p>
            </Link>
          </div>
          <a
            href={companyWebsite}
            className="card-link"
            target="_blank"
            rel="noreferrer"
          >
            Website
          </a>
        </div>
      </div>
    </div>
  );
}
